import ModalTrigger from './ModalTrigger'

export default function install(Vue) {
  Vue.component('ModalTrigger', ModalTrigger)
}
